<i18n>
{
  "fr": {
    "login-title": "Se connecter",
    "login-username-label": "Courriel",
    "login-password-label": "Mot de passe",
    "login-submit-btn": "Se connecter",
    "forgot-password-btn": "Mot de passe oublié?",
    "error-login-email-empty": "Le champ courriel ne doit pas être vide",
    "error-login-email-invalid": "Le courriel doit être dans un format valide : courriel@domaine.com",
    "error-login-password-empty": "Le champ mot de passe ne doit pas être vide",
    "privacy-policy-btn" : "Politique de confidentialité",
    "privacy-policy-url" : "https://coreplatform.ca/core-politique-de-protection-des-renseignements-personnels-et-politique-de-confidentialite"
  },
  "en": {
    "login-title": "Login",
    "login-username-label": "Email",
    "login-password-label": "Password",
    "login-submit-btn": "Login",
    "forgot-password-btn": "Forgot your password?",
    "error-login-email-empty": "The email field must not be empty.",
    "error-login-email-invalid": "The email address must be in a valid format: email@domain.com",
    "error-login-password-empty": "The password field must not be empty.",
    "privacy-policy-btn" : "Confidentiality Policy",
    "privacy-policy-url" : "https://coreplatform.ca/core-politique-de-protection-des-renseignements-personnels-et-politique-de-confidentialite "
  }
}
</i18n>

<template>
  <welcome>
    <h1 class="title">{{ $t('login-title') }}</h1>
    <s-form ref="form" @submit="login">
      <s-field :label="$t('login-username-label')" label-for="email" :value="email" :rules="rules.emailRules" validate-on-input>
        <b-input v-model="email" id="email"></b-input>
      </s-field>

      <s-field
        :label="$t('login-password-label')"
        label-for="password"
        :value="password"
        :rules="rules.passwordRules"
        validate-on-input
      >
        <b-input v-model="password" type="password" id="password"></b-input>
      </s-field>

      <p class="my-32px">
        <b-button :loading="loading" class="is-fullwidth" type="is-link" outlined size="is-medium" native-type="submit">
          {{ $t('login-submit-btn') }}
        </b-button>
      </p>
      <p class="has-text-centered">
        <b-button tag="router-link" :to="{ name: $consts.urls.URL_ACCOUNT_FORGOT_PASSWORD }" type="is-text">
          {{ $t('forgot-password-btn') }}
        </b-button>
      </p>
      <p class="has-text-centered">
        <b-button tag="a" :href="$t('privacy-policy-url')" target="_blank" type="is-text">
          {{ $t('privacy-policy-btn') }}
        </b-button>
      </p>
    </s-form>
  </welcome>
</template>

<script>
import SForm from '@/components/form/form'
import SField from '@/components/form/field'
import Welcome from '@/components/layout/welcome'

import AuthentificationService from '@/services/authentification'

import i18n from '@/helpers/i18n'
import FormHelper from '@/helpers/form'

export default {
  components: {
    SForm,
    SField,
    Welcome
  },
  data() {
    return {
      loading: false,
      rules: {
        emailRules: [
          (value) => !FormHelper.stringEmpty(value) || this.$t('error-login-email-empty'),
          (value) => FormHelper.isEmail(value) || this.$t('error-login-email-invalid')
        ],
        passwordRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-login-password-empty')]
      },
      email: this.$router.currentRoute.query.email || '',
      password: ''
    }
  },
  methods: {
    login: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          await AuthentificationService.login(this.email, this.password)
        } finally {
          this.loading = false
        }
      }
    },
    changeLang: function () {
      i18n.changeLang()
    }
  }
}
</script>
